export default __webpack_public_path__ + "static/media/image-3.e8b29b22.webp";